import React, { Component } from "react";
import { connect } from "react-redux";
import { Input, FormFeedback } from "reactstrap";

import historyAction from "../../redux/history/action";
import authAction from "../../redux/auth/action";
import mpAction from "../../redux/microPensionDublicated/action";
import InputComp from "../../component/InputComp/InputComp";

class BankDetails extends Component {
  state = {
    bankNameError: "",
    accountNameError: "",
    accountNumberError: "",
  };

  componentDidMount() {
    const { customRef } = this.props;

    customRef({ validate: this.validate });
  }

  validate = () => {
    // const { bankName, accountName, accountNumber } = this.props;

    let isValidated = true,
      bankNameError,
      accountNameError,
      accountNumberError;

    // if (!bankName) {
    //   bankNameError = "This field is required";
    //   isValidated = false;
    // }
    // if (!accountName) {
    //   accountNameError = "This field is required";
    //   isValidated = false;
    // }
    // if (!accountNumber) {
    //   accountNumberError = "This field is required";
    //   isValidated = false;
    // }

    this.setState({
      bankNameError,
      accountNameError,
      accountNumberError,
    });

    return isValidated;
  };

  render() {
    const {
      bankName,
      setBankDetailsField,
      accountNumber,
      accountName,
      allBanks,
    } = this.props;
    const { bankNameError, accountNumberError, accountNameError } = this.state;

    return (
      <div>
        <Input
          type="select"
          value={bankName}
          placeholder="Bank Name"
          containerStyles={{ width: "100%" }}
          onChange={(e) => {
            setBankDetailsField({ bankName: e.target.value });
          }}
        >
          <option value="" disabled selected>
            Bank Name*
          </option>
          {allBanks.map((item) => (
            <option key={Math.random().toString()} value={item.DESCRIPTION}>
              {item.DESCRIPTION}
            </option>
          ))}
        </Input>
        {!!bankNameError && (
          <FormFeedback invalid>{bankNameError}</FormFeedback>
        )}
        <InputComp
          type="text"
          value={accountName}
          errorMessage={accountNameError}
          placeholder="Bank Account Name"
          containerStyles={{ width: "100%" }}
          onChange={(e) => {
            setBankDetailsField({ accountName: e.target.value });
          }}
        />
        <InputComp
          type="text"
          value={accountNumber}
          errorMessage={accountNumberError}
          placeholder="Bank Account Number"
          containerStyles={{ width: "100%" }}
          onChange={(e) => {
            setBankDetailsField({ accountNumber: e.target.value });
          }}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.auth.user,
  ...state.microPensionDublicated.bankDetails,
  allBanks: state.referral.newReferral.allBanks,
});

const mapDispatchToProps = {
  setHistory: historyAction.setHistory,
  setBankDetailsField: mpAction.setBankDetailsField,
  setAlertMessage: authAction.setAlertMessage,
};

export default connect(mapStateToProps, mapDispatchToProps)(BankDetails);
